import React, { createContext, useContext, useState, useCallback } from 'react';
import type { LimitError } from './limitHandler';

interface LimitContextType {
  limitError: LimitError | null;
  showLimitError: (error: LimitError) => void;
  clearLimitError: () => void;
}

const LimitContext = createContext<LimitContextType | undefined>(undefined);

export function LimitProvider({ children }: { children: React.ReactNode }) {
  const [limitError, setLimitError] = useState<LimitError | null>(null);

  const showLimitError = useCallback((error: LimitError) => {
    setLimitError(error);
  }, []);

  const clearLimitError = useCallback(() => {
    setLimitError(null);
  }, []);

  return (
    <LimitContext.Provider value={{ limitError, showLimitError, clearLimitError }}>
      {children}
    </LimitContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useLimitContext() {
  const context = useContext(LimitContext);
  if (context === undefined) {
    throw new Error('useLimitContext must be used within a LimitProvider');
  }
  return context;
}
